<template>
	<div class="register-wrapper">
		<div class="mincontent">
			<div class="allContent">
				<iframe class="network_show" name="content_frame" :src="globalImgPath + '/docs/instruction.html'" frameborder=0
					scrolling="no"></iframe>
				
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getCurrentInstance,
	} from "vue";
	const uniHttp = getCurrentInstance().appContext.config.globalProperties;
	const globalImgPath = uniHttp.globalImgPath;
</script>



<style lang="less" scoped>
	.register-wrapper {

		height: 100%;
		overflow-x: hidden;
		overflow-y: hidden;
		background: #fff;
		width: 100%;
		.mincontent {
			width: calc(100% - 80px);
			margin-left: 40px;
			background: #fff;
			height: calc(100% - 40px);
		}

		.allContent {
			width: 90%;
			margin: 20px 5%;
			background: #fff;
			padding-top: 20px;
			padding-bottom: 30px;
			position: relative;
			height: 100%;
			.network_show {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>
